var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectronicsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57.495px",
    height: "57.495px",
    viewBox: "0 -2.76 57.495 57.495",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plug_electronics",
    "data-name": "plug electronics",
    d: "M264.006,517.911l-13.078,0a18.362,18.362,0,0,0-2.708-8.865,9,9,0,0,0-6.709-4.448v-.037H228.166a3.812,3.812,0,0,0-3.743-3.127h-3.5a3.821,3.821,0,0,0-3.815,3.814v6.414H211.6a1.272,1.272,0,1,0,0,2.543h5.511v10.6H211.6a1.275,1.275,0,0,0-1.272,1.272h0a1.277,1.277,0,0,0,1.272,1.275h5.511v5.083a3.821,3.821,0,0,0,3.815,3.814h3.5a3.814,3.814,0,0,0,3.545-2.434h13.543v-.039a8.994,8.994,0,0,0,6.709-4.453,18.33,18.33,0,0,0,2.708-8.862h13.078a1.287,1.287,0,0,1,1.27,1.272v21.832a1.29,1.29,0,0,1-1.27,1.273H236.238a3.818,3.818,0,0,0-3.815,3.813v4.769h2.544l0-4.769a1.288,1.288,0,0,1,1.274-1.27h27.768a3.825,3.825,0,0,0,3.814-3.816l0-21.832A3.823,3.823,0,0,0,264.006,517.911Zm-38.313,14.517a1.286,1.286,0,0,1-1.27,1.271h-3.5a1.291,1.291,0,0,1-1.273-1.271V505.245a1.294,1.294,0,0,1,1.273-1.273h3.5a1.29,1.29,0,0,1,1.27,1.273Zm2.6-1.166V507.1h10.679v24.161H228.289Zm17.8-3.331a6.605,6.605,0,0,1-4.576,3.295V507.138a6.6,6.6,0,0,1,4.576,3.294,17.534,17.534,0,0,1,0,17.5Z",
    transform: "translate(-210.327 -501.431)",
    fill: "#2c3233"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicsIcon);
export default __webpack_public_path__ + "static/media/electronics-icon.2f2f71bb.svg";
export { ForwardRef as ReactComponent };